import React, { FC } from 'react';

interface IPageLayout {
    title: string,
}

const PageLayout: FC<IPageLayout> = ({ children, title }) => {
    document.title = title ? `${title} - MoscowFlow CRM` : 'MoscowFlow CRM'
    return (
        <>
            {children}
        </>
    )
}

export default PageLayout;